window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['x-apikey'] = '123456';
window.Swal = require('sweetalert2')

let langPrefix = $('html').attr('lang') === 'ru' ? '/ru' : '';
let token = $('meta[name="csrf-token"]').attr('content');

import axios from 'axios';
import { Accordion } from './modules/accordion';

require('./modules/validator.js');
require('./modules/preloader');
require('@fancyapps/fancybox/dist/jquery.fancybox');
// require('./app.js')

import { Favorites } from './modules/favorites';

import { AppBasket } from './modules/order/basket';

// На айфонах превратится в touch, потом
window.click_event = 'click';

function shadowBody(visible) {
    let app = $('#app');
    visible ? app.addClass('shadow') : app.removeClass('shadow')
}

function menuVisibility(active, menuClass, animateBurger) {
    let menu = $(menuClass)
    if (active) {
        menu.addClass('show')
        if (animateBurger) {
            $('.burger').addClass('cross');
        }
        shadowBody(true);
    } else {
        $('.visibility-js').removeClass('show')
        $('.burger').removeClass('cross')
        shadowBody(false);
    }
}

// Модальные окна
function showModal(idModal, redirect) {
    $.fancybox.close();
    $.fancybox.open({
        src: '#' + idModal,
        type: 'inline',
        animationDuration: 200,
        touch: false,
        autoFocus: false,
        beforeShow: function () {
            $('#' + idModal).addClass('flex-wrapper')
        },
        beforeClose: function () {
            if (redirect) {
                document.location.href = '/'
            }
        }
    });
}


$(function () {

    // инициализация работы с избранным
    let favorite = new Favorites();
    favorite.init();

    // инициализация работы с корзиной
    let basketList = new AppBasket();


    let accordeon = new Accordion();
    
    let tokenPassword = $('meta[name="password-token"]').attr('content');
    if (tokenPassword && tokenPassword.length != 0) {
        showModal('changePassword', false);
    }

    // Бургер в меню
    $('.burger').on(click_event, function () {
        if ($(this).hasClass('cross')) {
            menuVisibility(false, '.main-menu', true);
        } else {
            menuVisibility(true, '.main-menu', true);
        }
    })

    $('.burger_mobile').on(click_event, function () {
        if ($(this).hasClass('cross')) {
            menuVisibility(false, '.main-menu', false);
        } else {
            menuVisibility(true, '.main-menu', true);
        }
    })

    $('.mobile-filter-button').on(click_event, function () {
        menuVisibility(true, '.sidebar', true);
    })

    $('#filter-form .button-next').on('click', function () {
        menuVisibility(false, '.sidebar', false);
    })

    $('.show_autorization_popup').on(click_event, function (e) {
        e.preventDefault();
        showModal('autorizationBlock', false)
    })

    $('.passwordRecovery-link').on(click_event, function (e) {
        e.preventDefault();
        showModal('passwordRecovery', false)
    })

    $(document).on(click_event, function (e) {
        if ($(e.target).hasClass('shadow')) {
            menuVisibility(false);
        }
    })

    // favorites
    // $(document).on(click_event, '.favoritesAdd', function (e) {
    //     e.stopPropagation()
    //     $(this).toggleClass('active');
    // })


    // Клик вне блока
    $(document).on(click_event, function (e) {
        e.stopPropagation();
        let hiddenList = $('.custom-select-wrapper');
        if (hiddenList.has(e.target).length == 0) {
            $('.hidden-list').removeClass('visible')
        }
        // if(!hiddenList.is(e.target) && hiddenList.has(e.target).length === 0){
        // }else{
        //     console.log('no')

        // }
        // var submenu = $(".main-menu .submenu")
        // if (!submenu.is(e.target) && submenu.has(e.target).length === 0 && !submenu.siblings('.main-menu__title').is(e.target)) {
        //     submenu.closest('.main-menu__item').removeClass('show-submenu')
        // }
    });


    $(document).on(click_event, '.accordion-item__header', function (e) {
        let accordionItem = $(this).closest('.accordion-item');
        if (!$(e.target).hasClass('repeat-order')) {
            accordeon.accordeonToggler(this)
        }
    })

    // сортировка в фильтре-меню
    $('.my-custom-select__name').on(click_event, function () {
        $(this).toggleClass('showOtions')
    });

    $('.my-custom-select__options.sort .option').on(click_event, function () {

        let text = $.trim($(this).text());
        let selectName = $(this).closest('.my-custom-select').find('.my-custom-select__name');
        selectName.text(text);
        selectName.removeClass('showOtions');
    })

    // Показать скрытый текст
    $('.show-text-button').on(click_event, function () {
        let seoBlockHeight = 0;
        let seoTextWrapper = $(this).siblings('.seo-text')
        let seoText = $(this).siblings('.seo-text').children();
        seoText.each(function () {
            seoBlockHeight += $(this).outerHeight();
        })
        seoTextWrapper.height(seoBlockHeight);
        $(this).hide()

        $('html, body').animate({
            scrollTop: $(".seo-text").offset().top
        }, 500);
    })

    // Маска телефона
    if ($('.phone-mask').length != 0) {
        let maskInput = function (input) {
            input.on("input", (e) => {
                let value = input.val().replace(/\D+/g, "");
                let numberLength = 12;
                let result;
                result = "+38 (";
                for (let i = 2; i < value.length && i < numberLength; i++) {
                    switch (i) {
                        case 5:
                            result += ") ";
                            break;
                        case 8:
                            result += "-";
                            break;
                        case 10:
                            result += "-";
                            break;
                        default:
                            break;
                    }
                    result += value[i];
                }
                input.val(result);
            });
            input.on("focus", (e) => {
                let value = input.val().replace(/\D+/g, "");
                if (value.length == 0) {
                    input.val("+38 (");
                }
            });
            input.on("blur", (e) => {
                let value = input.val().replace(/\D+/g, "");
                let numberLength = 12;

                if (value.length != numberLength) {
                    input.val('');
                }
            });
            input.on("mouseover", (e) => {
                input.attr('placeholder', '+38 (___) ___-__-__')
            });
            input.on("mouseout", (e) => {
                input.attr('placeholder', '+38')
            });
        };
        maskInput($('.phone-mask'));
    }

    // Показать/скрыть пароль
    $('.eye').on(click_event, function () {
        let type;
        $(this).toggleClass('show-password');
        $(this).hasClass('show-password') ? type = "text" : type = "password";
        $(this).siblings('input').attr('type', type)
    })

    // Поиск в хедере, анимация появления
    $('.search-form .submitBtn').on(click_event, function(e){
        e.preventDefault();
        if(!$(this).hasClass('show-input-js')){
            $(this).addClass('show-input-js');
            $(this).siblings('.searchInput').addClass('show-field');
        }else{
            let searchText = $('#headerSearchInput').val();
            window.location.href = langPrefix + '/categories/sort=sort;numbers=8;text=' + searchText + '/'
        }
    })

    $(document).on('click', '.count_click', function (e) {
        //e.preventDefault();
        let id = $(this).data('id');
        let href = $(this).attr('href');
        axios({
            method: 'POST',
            url: '/api/banner/count/add/',
            data: {id: id},
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
        .then(response => {
           // window.location = href;
            console.log(response.data)
        })
        .catch(error => {
            console.log(error)
        })    
    });
})